import React from 'react';
import './ActivityTab.css';
import VividLogo from '../../../assets/img/img_vi_loading_logo.png';

interface ActivityTabProps {
  isActive: boolean;
}

interface ActivityItem {
  id: string;
  type: 'like' | 'reply' | 'view' | 'collab' | 'application';
  user: {
    name: string;
    avatar: string;
  };
  content: string;
  timestamp: string;
  preview?: string;
}

const dummyActivities: ActivityItem[] = [
  {
    id: '1',
    type: 'like',
    user: { name: 'lets_bee', avatar: 'https://pixell.s3.us-east-2.amazonaws.com/post_images/brands/lets_bee.png' },
    content: 'Liked your post',
    timestamp: '2h',
    preview: 'sometimes doing makeup is like a speedru...'
  },
  {
    id: '2',
    type: 'reply',
    user: { name: 'lemonry', avatar: 'https://pixell.s3.us-east-2.amazonaws.com/post_images/brands/lemonny.png' },
    content: 'Replied to your post',
    timestamp: '4h',
    preview: 'ahhhh these are so so cute <3'
  },
  {
    id: '3',
    type: 'view',
    user: { name: 'System', avatar: VividLogo },
    content: 'Your post got over 2.7k views',
    timestamp: '5h'
  },
  {
    id: '4',
    type: 'collab',
    user: { name: 'AOU', avatar: 'https://pixell.s3.us-east-2.amazonaws.com/post_images/brands/aou.jpg' },
    content: 'Collab has opened',
    timestamp: '4h',
    preview: 'Glowy Tint Balm Collab is open!'
  },
  {
    id: '5',
    type: 'application',
    user: { name: 'AOU', avatar: 'https://pixell.s3.us-east-2.amazonaws.com/post_images/brands/aou.jpg' },
    content: 'You\'ve successfully applied',
    timestamp: '4h'
  },
  {
    id: '6',
    type: 'application',
    user: { name: 'AOU', avatar: 'https://pixell.s3.us-east-2.amazonaws.com/post_images/brands/aou.jpg' },
    content: 'Your application is in review',
    timestamp: '4h'
  },
  {
    id: '7',
    type: 'application',
    user: { name: 'AOU', avatar: 'https://pixell.s3.us-east-2.amazonaws.com/post_images/brands/aou.jpg' },
    content: 'Your application is accepted! 🎉 Check your email to start the collab now!',
    timestamp: '4h'
  },
];

const ActivityTab: React.FC<ActivityTabProps> = ({ isActive }) => {
  if (!isActive) return null;

  return (
    <div className="activity-tab">
      <header className="activity-header">
        <h1>Activity</h1>
      </header>
      <main className="activity-content">
        <div className="no-activity-message">
          There is no activity yet
        </div>
      </main>
    </div>
  );
};

export default ActivityTab;

export {}; // Ensure the file is treated as a module
